import React, {useState} from 'react';
import FilterContainer from './FilterContainer';

function FilterButtonGroup(props) {
  const {
    taxonomy,
    taxSlug,
    selected,
    displayPostCounts,
    label,
    labelTitle,
    collapsible,
    scrollable,
    mobileStyle,
    resetSelected,
    replaceSelected,
    isSelected
  } = props;

  const allTerms = [];
  const filterId = taxSlug ? `filter-${taxSlug}` : '';
  const labelTitleString = labelTitle ? labelTitle : 'All';

  let termContent;
  let prevButton;
  let nextButton;

  function resetCat(e) {
    e.preventDefault();
    resetSelected();
  }

  function changeCat(event, id) {
    event.preventDefault();
    replaceSelected(id, taxSlug);

    if (mobileStyle === 'scroll') {
      event.target.parentElement.scrollTo({
        left: event.target.offsetLeft - 30,
        behavior: 'smooth'
      });
    }
  }

  function prevCat(event) {
    event.preventDefault();
    let activeIndex = 0;
    let element;
    let parent = event.currentTarget.nextElementSibling;

    allTerms.forEach((term, index) => {
      if (term.props.id === selected[taxSlug][0]) {
        activeIndex = index;
      }
    });

    if (activeIndex > 1) {
      replaceSelected(allTerms[activeIndex - 1].props.id, taxSlug);
      element = parent.querySelector('button[id="' + allTerms[activeIndex - 1].props.id + '"]');
    } else if (activeIndex == 1) {
      resetSelected();
      element = parent.querySelector('button[id="0"]');
    }

    if (element) {
      parent.scrollTo({
        left: element.offsetLeft - 30,
        behavior: 'smooth'
      });
    }
  }

  function nextCat(event) {
    event.preventDefault();
    let activeIndex = 0;
    let element;
    let parent = event.currentTarget.previousElementSibling;

    allTerms.forEach((term, index) => {
      if (term.props.id === selected[taxSlug][0]) {
        activeIndex = index;
      }
    });

    if (activeIndex <= allTerms.length) {
      replaceSelected(allTerms[activeIndex + 1].props.id, taxSlug);
      element = parent.querySelector('button[id="' + allTerms[activeIndex + 1].props.id + '"]');
    }

    if (element) {
      parent.scrollTo({
        left: element.offsetLeft - 30,
        behavior: 'smooth'
      });
    }
  }

  function allClass() {
    let classString = '';

    if (selected[taxSlug] !== undefined && selected[taxSlug].length === 0) {
      classString = 'active';
    }

    return classString;
  }

  function termClass(id) {
    let classString = '';

    if (isSelected(id, taxSlug)) {
      classString = 'active';
    }

    return classString;
  }

  if (taxonomy) {
    allTerms.push(
        <button 
          key={0}
          id="0"
          onClick={(e) => resetCat(e)}
          className={allClass()}
        >
        {labelTitleString}
        </button>
    );

    taxonomy.forEach(term => {
      if (displayPostCounts) {
        termContent = `${term.name} (${term.count})`;
      }
      else {
        termContent = term.name;
      }

      allTerms.push(
        <button 
          key={term.id}
          id={term.id}
          onClick={(e) => changeCat(e, term.id)}
          className={termClass(term.id)}
        >
        {termContent}
        </button>
      )
    });
  }

  if (mobileStyle === 'scroll') {
    prevButton = 
      <button onClick={(e) => prevCat(e)} aria-label='Previous Category' className='filter-button-group__prev-button'>
        <i className='icon-left-chev'></i>
      </button>

    nextButton = 
      <button onClick={(e) => nextCat(e)} aria-label='Next Category' className='filter-button-group__next-button'>
        <i className='icon-right-chev'></i>
      </button>
  }

  return (
    <FilterContainer 
    className="filter-button-group"
    label={label}
    selected={selected}
    taxSlug={taxSlug}
    filterId={filterId}
    collapsible={collapsible}
    scrollable={scrollable}
    >
      {prevButton}

      <div className="button-wrap">
        {allTerms}
      </div>

      {nextButton}
    </FilterContainer>
  )
}

export default FilterButtonGroup;